import { ElementType, IElement } from "../IProcessData";
import { FileWatchTriggerConfig, FileWatchTriggerConfigV1, Triggers } from "../ITriggerData";
import { IMigrationParameters } from "./index";

export function migrate(migrateParameters: IMigrationParameters) {
    const element = migrateParameters.element;
    if (element &&
        element.type === ElementType.Start &&
        element.selectedTypeId === Triggers.FileWatchTrigger.triggerType) {
        const existingParameters: FileWatchTriggerConfig = element.parameters as any;
        if (!existingParameters.version) {
            // no version tag, will need to migrate
            const existingParametersV1: FileWatchTriggerConfigV1 = element.parameters as any;
            const migratedParameters: FileWatchTriggerConfig = {
                version: 2,
                dirToWatch: existingParametersV1.dirToWatch,
                fileMask: existingParametersV1.fileMask,
                includeSubDirectories: existingParametersV1.includeSubDirectories || false,
                maxFilesPerBatch: existingParametersV1.batchTriggerEvents ? 1000 : 1,
                pollIntervalSeconds: 10,
                username: existingParameters.username,
                password: existingParameters.password
            };
            const migratedElement = Object.assign({}, element, {parameters: migratedParameters});
            return migratedElement;
        }
    }
    return element;
}
